import { Component, input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TNil } from '@app/app.interface';
import { NumberOnlyDirective } from '@app/core/directives/number-only-directive';
import { CustomCtaBaseDirective, ECustomFieldType } from '@core/directives/custom-cta-base.directive';
import { CustomValuesService } from '@core/services/custom-values.service';
import { EAnalyticsStatus } from '@enums/campaign-analytics.enum';
import { EDeliverableType, EPlatformFeature } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { CustomRemoveButtonComponent } from '@shared/components/custom-remove-button/custom-remove-button.component';
import { EditableTitleComponent } from '@shared/components/editable-title/editable-title.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { StatusBadgeComponent } from '@shared/components/status-badge/status-badge.component';
import { DeliverableAdvancedButtonComponent } from '../advanced-button/deliverable-advanced-button.component';
import { DeliverableAdvancedSettingsSectionComponent } from '../advanced-settings-section/deliverable-advanced-settings-section.component';

@Component({
  imports: [
    DeliverableAdvancedButtonComponent,
    DeliverableAdvancedSettingsSectionComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatErrorComponent,
    NumberOnlyDirective,
    MatTooltipModule,
    MatCheckboxModule,
    EditableTitleComponent,
    MatExpansionModule,
    IconComponent,
    CustomRemoveButtonComponent,
    StatusBadgeComponent,
  ],
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
})
export class ChatbotComponent extends CustomCtaBaseDirective implements OnInit {
  public readonly platformFeature = input<EPlatformFeature | null | undefined>(null);
  public readonly statusText = input<EAnalyticsStatus | TNil>(undefined);
  public readonly statusInterval = input<EAnalyticsStatus | TNil>(undefined);

  protected readonly customValueConfig = {
    componentFields: {
      getForm: (): FormGroup => this.form(),
      managedFields: [
        { name: 'interval', type: ECustomFieldType.string },
        { name: 'text', type: ECustomFieldType.string },
        { name: 'id', type: ECustomFieldType.string },
        { name: 'sponsoredContentRelevant', type: ECustomFieldType.boolean },
      ],
    },
  };

  constructor(customValuesService: CustomValuesService) {
    super(customValuesService);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.autoOpenAdvancedSettingsIfNeeded(this.platformFeature(), this.form().get('type')?.value as EDeliverableType);
  }
}
